import { cn } from "@/libs/cn";
import { cva } from "class-variance-authority";
import { createSignal, Show, splitProps } from "solid-js";
import { Icon } from "@iconify-icon/solid";
import { Button } from "@/components/shadcn/button"
import { Calendar } from "@/components/shadcn/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/shadcn/popover"

export const DatePicker = (props) => {
  const [activeDate, setActiveDate] = createSignal(props.value);

  const onDateChange = (date) => {
    setActiveDate(date);
    props.onChange?.(date);
  }

  const date = () => {
    return props.value ?? activeDate();
  }

  const value = () => {
    if (!date()) {
      return "No Date Selected";
    }

    return date().format("LL");
  }

  return (
    <Popover>
      <Show when={!props.disabled}>
        <PopoverTrigger as={(innerProps) => <Button variant={"outline"}
          class={cn(
            "justify-start text-left font-normal",
            !date() && "text-muted-foreground",
            props.inputClass
          )} {...innerProps} />}>
          <Icon icon="lucide:calendar" class="mr-2 h-4 w-4" />
          <span>{value()}</span>
        </PopoverTrigger>
      </Show>
      <Show when={props.disabled}>
        <Button variant={"outline"}
          disabled={true}
          class={cn(
            "justify-start text-left font-normal",
            !date() && "text-muted-foreground",
            props.inputClass
          )}>
          <Icon icon="lucide:calendar" class="mr-2 h-4 w-4" />
          <span>{value()}</span>
        </Button>
      </Show>
      <PopoverContent class="w-auto px-0.5 py-1" showCloseButton={false}>
        <Calendar
          date={date()}
          onChange={onDateChange}
        />
      </PopoverContent>
    </Popover>
  );
}

export const DateRangePicker = (props) => {

  const [startDate, setStartDate] = createSignal(props.startDate);
  const [endDate, setEndDate] = createSignal(props.endDate);

  const value = () => {
    if (!startDate()) {
      return "No Date Selected";
    }

    if (!endDate() || startDate().isSame(endDate(), "day")) {
      return startDate().format("LL");
    }

    return startDate().format("LL") + " - " + endDate().format("LL");
  }

  const onRangeChange = (range) => {
    setStartDate(range.startDate);
    setEndDate(range.endDate);
    props.onRangeChange?.(range);
  }

  return (
    <Popover>
      <PopoverTrigger as={(innerProps) => <Button variant={"outline"}
        class={cn(
          "justify-start text-left font-normal",
          !startDate() && "text-muted-foreground",
          props.inputClass
        )} {...innerProps} />}>
        <Icon icon="lucide:calendar" class="mr-2 h-4 w-4" />
        <span>{value()}</span>
      </PopoverTrigger>
      <PopoverContent class="w-auto px-0.5 py-1" showCloseButton={false}>
        <Calendar
          mode="range"
          date={startDate()}
          endDate={endDate()}
          onChange={onRangeChange}
        />
      </PopoverContent>
    </Popover>
  );
}
